import FormClient from "./FormClient";

export default function YearColorFormPage() {
    return <FormClient />;
}

